import { CommonModule } from '@angular/common';
import {
  Component,
  HostBinding,
  booleanAttribute,
  computed,
  input,
  signal,
} from '@angular/core';
import { Color, LepiIcon, Size, Variant } from '@lepisode-ui/components';
import { BUTTON_SIZE, BUTTON_STATE_STYLE, BUTTON_STYLE } from './button.common';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule, LepiIcon],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @HostBinding('class') get hostClasses() {
    if (this.expand()) {
      return 'w-full';
    }

    return '';
  }

  color = input<Color>('primary');
  size = input<Size>('md');
  variant = input<Variant>('solid');
  type = input<'button' | 'submit'>('button');
  width = input<string>('min-w-max');
  icon = input<string | null>(null);
  expand = input<boolean, string | boolean>(false, {
    transform: booleanAttribute,
  });
  disabled = input<boolean, string | boolean>(false, {
    transform: booleanAttribute,
  });

  readonly styles = signal(BUTTON_STYLE);
  readonly stateStyles = signal(BUTTON_STATE_STYLE);

  readonly currentStyle = computed<string>(
    () => this.styles()[this.variant()][this.color()],
  );
  readonly currentStateStyle = computed<string>(
    () => this.stateStyles()[this.variant()][this.color()],
  );
  readonly currentSize = computed<string>(() => BUTTON_SIZE[this.size()]);
}
